// // import { Box, Table, Thead, Tbody, Tr, Th, Td, Text } from "@chakra-ui/react";
// // import React from "react";

// // const dadosExemplo = [
// //   {
// //     segmento: "Alimentos",
// //     percFaturamento: "35%",
// //     faturamento: "R$ 120.000,00",
// //     custo: "R$ 80.000,00",
// //     lucro: "R$ 40.000,00",
// //     margem: "33,3%"
// //   },
// //   {
// //     segmento: "Bebidas",
// //     percFaturamento: "25%",
// //     faturamento: "R$ 85.000,00",
// //     custo: "R$ 55.000,00",
// //     lucro: "R$ 30.000,00",
// //     margem: "35,3%"
// //   },
// //   {
// //     segmento: "Higiene",
// //     percFaturamento: "20%",
// //     faturamento: "R$ 68.000,00",
// //     custo: "R$ 40.000,00",
// //     lucro: "R$ 28.000,00",
// //     margem: "41,2%"
// //   },
// //   {
// //     segmento: "Limpeza",
// //     percFaturamento: "12%",
// //     faturamento: "R$ 40.000,00",
// //     custo: "R$ 25.000,00",
// //     lucro: "R$ 15.000,00",
// //     margem: "37,5%"
// //   },
// //   {
// //     segmento: "Outros",
// //     percFaturamento: "8%",
// //     faturamento: "R$ 27.000,00",
// //     custo: "R$ 15.000,00",
// //     lucro: "R$ 12.000,00",
// //     margem: "44,4%"
// //   }
// // ];

// // export default function CategoriaTabela() {
// //   return (
// //     <Box
// //       bg="whiteAlpha.900"
// //       borderRadius="lg"
// //       boxShadow="lg"
// //       p={4}
// //       overflowX="auto"
// //       mb={2}
// //     >
// //       <Text fontWeight="bold" fontSize={{ base: "lg", md: "xl" }} mb={4} color="gray.700">
// //         Segmentos - Resumo Financeiro
// //       </Text>
// //       <Table variant="simple" size="sm">
// //         <Thead>
// //           <Tr bg="blue.800">
// //             <Th color="white" fontWeight="bold">Segmento</Th>
// //             <Th color="white" fontWeight="bold">% Faturamento</Th>
// //             <Th color="white" fontWeight="bold">Faturamento Total</Th>
// //             <Th color="white" fontWeight="bold">Custo Total</Th>
// //             <Th color="white" fontWeight="bold">Lucro Segmento</Th>
// //             <Th color="white" fontWeight="bold">Margem Segmento</Th>
// //           </Tr>
// //         </Thead>
// //         <Tbody>
// //           {dadosExemplo.map((item, idx) => (
// //             <Tr key={idx} _hover={{ bg: "gray.100" }}>
// //               <Td color="gray.700" fontWeight="semibold">{item.segmento}</Td>
// //               <Td color="gray.700">{item.percFaturamento}</Td>
// //               <Td color="gray.700">{item.faturamento}</Td>
// //               <Td color="gray.700">{item.custo}</Td>
// //               <Td color="gray.700">{item.lucro}</Td>
// //               <Td color="gray.700">{item.margem}</Td>
// //             </Tr>
// //           ))}
// //         </Tbody>
// //       </Table>
// //     </Box>
// //   );
// // }

// import { Box, Table, Thead, Tbody, Tr, Th, Td, Text, Flex } from "@chakra-ui/react";
// import React from "react";

// // Função para formatar valores em reais
// function formatarValor(valor) {
//   return valor?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) || "R$ 0,00";
// }

// export default function TabelaSeg({ dados = [] }) {
//   // Soma do faturamento total
//   const totalFaturamento = dados.reduce((acc, item) => acc + (Number(item.faturamentoTotal) || 0), 0);

//   return (
//     <Box
//       bg="whiteAlpha.900"
//       borderRadius="lg"
//       boxShadow="lg"
//       p={4}
//       overflowX="auto"
//       mb={2}
//     >
//       <Flex justify="space-between" align="center" mb={2}>
//         <Text fontWeight="bold" fontSize={{ base: "lg", md: "xl" }} color="gray.700">
//           Faturamento por Categoria
//         </Text>
//         <Text
//           fontWeight="bold"
//           fontSize={{ base: "md", md: "lg" }}
//           color="blue.800"
//           bg="blue.100"
//           px={4}
//           py={1}
//           borderRadius="md"
//         >
//           Total Faturamento: {formatarValor(totalFaturamento)}
//         </Text>
//       </Flex>
//       <Table variant="simple" size="sm">
//         <Thead>
//           <Tr bg="blue.800">
//             <Th color="white" fontWeight="bold">Categoria</Th>
//             <Th color="white" fontWeight="bold">% Faturamento</Th>
//             <Th color="white" fontWeight="bold">Faturamento Total</Th>
//             <Th color="white" fontWeight="bold">Custo Total</Th>
//             <Th color="white" fontWeight="bold">Lucro Categoria</Th>
//             <Th color="white" fontWeight="bold">Margem Categoria</Th>
//           </Tr>
//         </Thead>
//         <Tbody>
//           {dados.map((item, idx) => (
//             <Tr key={idx} _hover={{ bg: "gray.100" }}>
//               <Td color="gray.700" fontWeight="semibold">{item.categoria}</Td>
//               <Td color="gray.700">{Number(item.percentualFaturamento).toFixed(2)}%</Td>
//               <Td color="gray.700">{formatarValor(item.faturamentoTotal)}</Td>
//               <Td color="gray.700">{formatarValor(item.custoTotal)}</Td>
//               <Td color="gray.700">{formatarValor(item.lucroCategoria)}</Td>
//               <Td color="gray.700">{Number(item.margemCategoria).toFixed(2)}%</Td>
//             </Tr>
//           ))}
//         </Tbody>
//       </Table>
//     </Box>
//   );
// }


import { Box, Table, Thead, Tbody, Tr, Th, Td, Text, Flex, Button } from "@chakra-ui/react";
import React, { useState } from "react";

// Função para formatar valores em reais
function formatarValor(valor) {
  return valor?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) || "R$ 0,00";
}

export default function TabelaSeg({ dados = [] }) {
  const [expandido, setExpandido] = useState(false);
  const LIMITE = 10;

  // Soma do faturamento total
  const totalFaturamento = dados.reduce((acc, item) => acc + (Number(item.faturamentoTotal) || 0), 0);

  // Decide quais linhas mostrar
  const dadosExibidos = expandido ? dados : dados.slice(0, LIMITE);

  return (
    <Box
      bg="whiteAlpha.900"
      borderRadius="lg"
      boxShadow="lg"
      p={4}
      overflowX="auto"
      mb={2}
    >
      <Flex justify="space-between" align="center" mb={2}>
        <Text fontWeight="bold" fontSize={{ base: "lg", md: "xl" }} color="gray.700">
          Faturamento por Categoria
        </Text>
        <Text
          fontWeight="bold"
          fontSize={{ base: "md", md: "lg" }}
          color="blue.800"
          bg="blue.100"
          px={4}
          py={1}
          borderRadius="md"
        >
          Total Faturamento: {formatarValor(totalFaturamento)}
        </Text>
      </Flex>
      <Table variant="simple" size="sm">
        <Thead>
          <Tr bg="blue.800">
            <Th color="white" fontWeight="bold">Categoria</Th>
            <Th color="white" fontWeight="bold">% Faturamento</Th>
            <Th color="white" fontWeight="bold">Faturamento Total</Th>
            <Th color="white" fontWeight="bold">Custo Total</Th>
            <Th color="white" fontWeight="bold">Lucro Categoria</Th>
            <Th color="white" fontWeight="bold">Margem Categoria</Th>
          </Tr>
        </Thead>
        <Tbody>
          {dadosExibidos.map((item, idx) => (
            <Tr key={idx} _hover={{ bg: "gray.100" }}>
              <Td color="gray.700" fontWeight="semibold">{item.categoria}</Td>
              <Td color="gray.700">{Number(item.percentualFaturamento).toFixed(2)}%</Td>
              <Td color="gray.700">{formatarValor(item.faturamentoTotal)}</Td>
              <Td color="gray.700">{formatarValor(item.custoTotal)}</Td>
              <Td color="gray.700">{formatarValor(item.lucroCategoria)}</Td>
              <Td color="gray.700">{Number(item.margemCategoria).toFixed(2)}%</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      {dados.length > LIMITE && (
        <Flex justify="center" mt={2}>
          <Button
            size="sm"
            colorScheme="blue"
            variant="outline"
            onClick={() => setExpandido((v) => !v)}
          >
            {expandido ? "Ver menos" : `Ver mais (${dados.length - LIMITE})`}
          </Button>
        </Flex>
      )}
    </Box>
  );
}